const {
  iterableCurry
} = require('../../internal/iterable.js');

const {
  __map
} = require('../$map/map.js');

function* __flatMap(source, func) {
  for (const value of __map(source, func)) {
    yield* value;
  }
}

exports.__flatMap = __flatMap;
const flatMap = /*#__PURE__*/iterableCurry(__flatMap);
exports.flatMap = flatMap;